import React, { useEffect, useState } from 'react'
import useMedia from '@/hook/useMedia'
import { arrayOf, bool, node, oneOf, string, object } from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import styles from './WidgetWrapper.module.scss'

const possibleDisplayOptions = ['desktop', 'tablet', 'mobile']

const WidgetWrapper = ({
  children,
  displayOptions,
  essential,
  sticky,
  id,
  showWhenEventIs,
  pageData
}) => {
  showWhenEventIs = showWhenEventIs || []

  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  const hiddenBreakpoints = possibleDisplayOptions.filter(
    (option) => !displayOptions.includes(option)
  )

  const isMobile = useMedia('(max-width: 959px)')
  const isHiddenOnMobile =
    hiddenBreakpoints.includes('tablet') && hiddenBreakpoints.includes('mobile')
  const isHiddenOnDesktop = hiddenBreakpoints.includes('desktop')

  if (isMobile && isHiddenOnMobile) return false
  if (!isMobile && isHiddenOnDesktop) return false

  // Check if widget should be hidden based on event status
  if (pageData?.eventUmbrella?.event && showWhenEventIs.length > 0) {
    const event = pageData.eventUmbrella.event
    const now = moment()
    const startDate = moment(event.startDate)
    const endDate = moment(event.endDate)

    const isBefore = now.isBefore(startDate)
    const isLive = now.isBetween(startDate, endDate, null, '[]') // inclusive range
    const isAfter = now.isAfter(endDate)

    // Check if the current event status matches any of the selected options
    const shouldShowBefore = showWhenEventIs.includes('before') && isBefore
    const shouldShowLive = showWhenEventIs.includes('live') && isLive
    const shouldShowAfter = showWhenEventIs.includes('after') && isAfter

    // If no condition is met, hide the widget
    if (!(shouldShowBefore || shouldShowLive || shouldShowAfter)) {
      return null
    }
  }

  return (
    <div
      className={classNames(
        styles.WidgetWrapper,
        sticky && styles.sticky,
        hiddenBreakpoints.map((breakpoint) => styles[`hidden-${breakpoint}`])
      )}
    >
      {(essential || (!essential && mounted)) && children}
      <div id={id} className={styles.Anchor} />
    </div>
  )
}

WidgetWrapper.defaultProps = {
  essential: true,
  displayOptions: [],
  showWhenEventIs: []
}

WidgetWrapper.propTypes = {
  id: string,
  children: node.isRequired,
  essential: bool,
  displayOptions: arrayOf(oneOf(possibleDisplayOptions)).isRequired,
  sticky: bool,
  showWhenEventIs: arrayOf(oneOf(['before', 'live', 'after'])),
  pageData: object
}

export default WidgetWrapper
